var render = function render(){var _vm=this,_c=_vm._self._c;return _c('message-template',{attrs:{"icon":"/illustration-sleepy-basket.svg","text":"Your job here is done.","additional-text":"There are no awaiting orders."}})
}
var staticRenderFns = []

export { render, staticRenderFns }